import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CommonTextfieldComponent } from './textfield.component';
import { CommonLoaderModule } from '../loader/loader.module';
import { CommonValidationModule } from '../control/validation/validation.module';
import { CommonTextfieldInputMaskAliasesService } from './inputmasks_aliases_service';

@NgModule({
    imports: [
        CommonModule,
        CommonValidationModule,
        CommonLoaderModule,
    ],
    declarations: [
        CommonTextfieldComponent,
    ],
    providers: [
        CommonTextfieldInputMaskAliasesService,
    ],
    exports: [
        CommonTextfieldComponent,
        CommonModule,
        FormsModule,
        CommonValidationModule,
    ]
})
export class CommonTextfieldModule {}

